import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=6ab24e9c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab24e9c",
  null
  
)

export default component.exports